import { Injectable } from '@angular/core';

/**
 * Ensures only one top-level mega menu is open at a time (same behavior as mat-menu stacks).
 */
@Injectable({ providedIn: 'root' })
export class MegaMenuCoordinatorService {
  private activeCloser: (() => void) | null = null;

  /** Call before attaching a new mega menu overlay. */
  openExclusive(closeSelf: () => void): void {
    if (this.activeCloser && this.activeCloser !== closeSelf) {
      this.activeCloser();
    }
    this.activeCloser = closeSelf;
  }

  /** Call when this mega menu is fully closed. */
  closed(closeSelf: () => void): void {
    if (this.activeCloser === closeSelf) {
      this.activeCloser = null;
    }
  }
}
